<template>
    <div>
        <a-button class="top_btn" type="primary" @click="()=>{  visibleForm = true; titleForm='添加角色' }" v-has="'btn_add'"  > 添加角色
        </a-button>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id">
          <span slot="status" slot-scope="text, record" >
              <a-switch   @click="onChange(record)" :checked="text==1?true:false" :disabled="!$_has('btn_status')||record.id==1"  /> </span>
          <span slot="action" slot-scope="text, record"  v-if=" record.id!=1">
              <i v-if="$_hasAll(['btn_role','btn_edit','btn_delete'])" style="color:#838383">暂无操作权限</i>
          <a @click="(record) => { visibleJurisdiction = true; titleForm='权限设置';jurisdictionId=text.id ;  }" v-has="'btn_role'">权限设置</a>
              <a-divider type="vertical"/>
        <a @click="(record)=>{visibleForm = true; titleForm='修改角色'; editId=text.id ; }" v-has="'btn_edit'">编辑</a>
              <a-divider type="vertical"/>
          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm(record)"
                  @cancel="()=>{}"
          >
            <a v-has="'btn_delete'">删除</a>
        </a-popconfirm>
      </span>
        </a-table>
        <RoleForm :visible="visibleForm" :title="titleForm" :editId="editId"
                  @changVisible=" () => { this.visibleForm = false;this.editId='';  this.getList()}  "/>
        <JurisdictionForm :visibleJurisdiction="visibleJurisdiction" :title="titleForm" :jurisdictionId="jurisdictionId"
                          @changVisible=" () => { this.visibleJurisdiction = false;this.jurisdictionId='';  this.getList()}  "
        />
    </div>

</template>

<script>
    import API from "./api";
    import JurisdictionForm from "./components/jurisdictionForm"
    import RoleForm from "./components/roleForm"
    import {changStatus, removeById} from "../../utils/utils"
    const columns = [
        {
            title: "角色名称",
            dataIndex: "name",
            width: "20%",
            ellipsis: true,
            key: "name"
        },
        {
            title: "角色描述",
            dataIndex: "remark",
            ellipsis: true,
            key: "remark"
        },
        {
            title: "状态",
            key: "status",
            width: "10%",
            dataIndex: "status",
            scopedSlots: {customRender: "status"}
        },
        {
            title: "操作",
            key: "action",
            width: "200px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: 'RoleList',
        data() {
            return {
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                visibleForm: false,
                titleForm: "",
                loading: true,
                editId: null,
                jurisdictionId: null,
                visibleJurisdiction: false,
                data: [],
                columns,
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/Administrator/RoleList"; //设置左侧导航2-2 active
        },
        components: {RoleForm, JurisdictionForm},
        methods: {
            getList(page) {
                this.loading = true
                API.administrator.GET_AROLE(page || 1).then(res => {
                    this.pagination.total = res.data.data.total
                    this.pagination.pageSize = res.data.data.per_page
                    this.pagination.current = res.data.data.current_page
                    this.data = res.data.data.data
                    this.loading = false
                })
            },
            onChange(row) {
                let Json = {id: row.id, status: row.status == 0 ? 1 : 0}
                changStatus(API.administrator.CHANG_STATUS, [Json]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })

            },
            confirm(row) {
                removeById( API.administrator.DELE, [row.id]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
        },
        mounted() {
            this.getList()
        }

    }
</script>
